import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Tab {
  id: string;
  label: string;
}

@Component({
  selector: 'ui-tabs',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="border-b border-slate-200 mb-4">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <button
          *ngFor="let tab of tabs"
          (click)="onTabClick(tab.id)"
          [class]="getTabClasses(tab.id)"
          role="tab"
          [attr.aria-selected]="tab.id === activeTab"
        >
          {{ tab.label }}
        </button>
      </nav>
    </div>
  `,
  styles: [`
    button {
      @apply whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm;
    }
  `]
})
export class TabsComponent {
  @Input() tabs: Tab[] = [];
  @Input() activeTab = '';
  @Output() activeTabChange = new EventEmitter<string>();
  @Output() tabChange = new EventEmitter<string>();

  onTabClick(tabId: string): void {
    this.activeTab = tabId;
    this.activeTabChange.emit(tabId);
    this.tabChange.emit(tabId);
  }

  getTabClasses(tabId: string): string {
    const baseClasses = 'hover:text-primary-600 hover:border-primary-600';
    const activeClasses = 'border-primary-600 text-primary-600';
    const inactiveClasses = 'border-transparent text-slate-500';

    return `${baseClasses} ${
      tabId === this.activeTab ? activeClasses : inactiveClasses
    }`;
  }
}
